import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import heic2any from "heic2any";

const AccountDetails = () => {
  const jwtToken = localStorage.getItem("jwt_token");

  const [userDetail, setUserDetail] = useState({
    first_name: "",
    last_name: "",
    email: "",
    type_of_account: "",
    phone_number: "",
    password: "",
    type: "",
    organisation_and_role: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [formFamilyValues, setFormFamilyValues] = useState([
    { id: 1, email: "" },
  ]);
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    getAccountDetail();
  }, []);

  const onChangeHandler = (e) => {
    setUserDetail({ ...userDetail, [e.target.id]: e.target.value });
  };

  const getAccountDetail = async () => {
    const id = localStorage.getItem("user_id");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/people/${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      const accountDetails = data.data.people_details;

      if (localStorage.getItem("type") === "Private") {
        const familyEmails =
          accountDetails?.organisation_and_role[0]?.family_members_email || [];
        const formattedFamilyEmails = familyEmails.map((email, index) => ({
          id: index + 1,
          email,
        }));
        setFormFamilyValues(formattedFamilyEmails);
      }

      setUserDetail({
        first_name: accountDetails.first_name,
        last_name: accountDetails.last_name,
        email: accountDetails.email,
        type: accountDetails.type,
        type_of_account: accountDetails.account_type,
        phone_number: accountDetails.phone_number,
        organisation_and_role: accountDetails.organisation_and_role || [],
      });
      setSelectedImage(accountDetails.profile_image)
    } catch (error) {
      toast.error(error.message);
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loader
    const id = localStorage.getItem("user_id");

    const body = {
      first_name: userDetail.first_name,
      last_name: userDetail.last_name,
      email: userDetail.email,
      phone_number: userDetail.phone_number,
      password: userDetail.password,
      account_type: userDetail.type_of_account,
      profile_image: selectedImage || null,
    };

    if (localStorage.getItem("type") === "Private") {
      const emailFamilyArray = formFamilyValues.map((element) => element.email);
      body.family_members_email = emailFamilyArray.includes(undefined)
        ? null
        : emailFamilyArray;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/people/${id}`,
        {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      if (response.ok) {
        setIsSubmitting(false)
      }
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
      setIsSubmitting(false)
    }
  };

  const addFormFamilyFields = () => {
    const newId = formFamilyValues.length
      ? formFamilyValues[formFamilyValues.length - 1].id + 1
      : 1;
    setFormFamilyValues([...formFamilyValues, { id: newId, email: "" }]);
  };

  const removeFormFamilyFields = (index) => {
    const newFormValues = [...formFamilyValues];
    newFormValues.splice(index, 1);
    setFormFamilyValues(
      newFormValues.length > 0 ? newFormValues : [{ id: 1, email: "" }]
    );
  };

  const onChangeHandler1 = (e, id) => {
    const formValuesCopy = [...formFamilyValues];
    const index = formValuesCopy.findIndex((element) => element.id === id);
    if (index !== -1) {
      formValuesCopy[index].email = e.target.value;
      setFormFamilyValues(formValuesCopy);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = file.type;

    if (fileType === "image/heic" || fileType === "image/heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });

        // If heic2any returns an array (in some cases), take the first blob
        const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImage(reader.result);
        };
        reader.readAsDataURL(finalBlob);
      } catch (err) {
        console.error("HEIC conversion failed:", err);
        toast.error("Failed to load HEIC image.");
      }
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <div className="">
        <h6 className="text-bold">Account Details</h6>
        <div className="row justify-content-center mb-2">
          <div className="col-auto text-center">
            <label style={{ fontWeight: 500 }}>Profile Photo:</label>
            <div className="d-flex justify-content-center">
              {selectedImage ? (
                <div
                  style={{
                    position: "relative",
                    width: "150px",
                    height: "150px",
                  }}
                >
                  <img
                    src={selectedImage}
                    alt="Profile Preview"
                    className="img-thumbnail rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    className="btn btn-danger btn-sm"
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      padding: 0,
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <label htmlFor="upload-image" className="d-block">
                  <div
                    className="d-flex justify-content-center align-items-center border rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      cursor: "pointer",
                      border: "2px dashed #ccc",
                      textAlign: "center",
                      fontSize: "14px",
                      padding: "20px",
                    }}
                  >
                    Upload your profile photo
                  </div>
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp, image/heic, image/heif"
                    id="upload-image"
                    onChange={handleImageUpload}
                    style={{ display: "none" }}
                  />
                </label>
              )}
            </div>
          </div>
        </div>

        <form onSubmit={onSubmitHandler}>
          <div className="row g-2">
            <div className="col-md-6">
              <label htmlFor="first_name">First name:</label>
              <input
                type="text"
                className="form-control"
                id="first_name"
                value={userDetail.first_name}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="last_name">Last name:</label>
              <input
                type="text"
                className="form-control"
                id="last_name"
                value={userDetail.last_name}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="email">Email address:</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={userDetail.email}
                disabled
              />
            </div>

            {localStorage.getItem("type") === "Private" && (
              <div className="col-md-12">
                <label>Family Member Email address:</label>
                {formFamilyValues.map((element, index) => (
                  <div className="row mb-2" key={index}>
                    <div className="col-10 col-md-11">
                      <input
                        type="email"
                        className="form-control"
                        value={element.email}
                        onChange={(e) => onChangeHandler1(e, element.id)}
                      />
                    </div>
                    <div className="col-2 col-md-1">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeFormFamilyFields(index)}
                      >
                        -
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={addFormFamilyFields}
                >
                  + Add Email
                </button>
              </div>
            )}

            <div className="col-md-6">
              <label htmlFor="type_of_account">Account Type:</label>
              <input
                type="text"
                className="form-control"
                id="type_of_account"
                disabled
                value={userDetail.type}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="phone_number">Phone number:</label>
              <input
                type="number"
                className="form-control"
                id="phone_number"
                value={userDetail.phone_number}
                onChange={onChangeHandler}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="password">Change Password:</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={userDetail.password}
                onChange={onChangeHandler}
              />
            </div>
          </div>

          {userDetail.organisation_and_role?.length > 0 && (
            <div className="row mt-4">
              <div className="col-md-12">
                <h6 className="text-bold">Organisation Roles</h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Organisation Name</th>
                      <th>Role Permission</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userDetail.organisation_and_role.map((org, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{org.organisation_name}</td>
                        <td>{org.role}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="mt-4">
            <button
              type="submit"
              className="btn mb-4 bg_color d-flex align-items-center"
              disabled={isSubmitting}
            >
              Save Changes
              {isSubmitting && (
                <span
                  className="spinner-border spinner-border-sm ms-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AccountDetails;
